

import * as React from "react"
import { Moon, Sun, Palette } from "lucide-react"
import { useTheme } from "@/lib/theme"
import { Button } from "@/components/ui/button"
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu"

export function ThemeToggle() {
  const [mounted, setMounted] = React.useState(false)
  const { theme, setTheme, resolvedTheme } = useTheme()

  React.useEffect(() => {
    setMounted(true)
  }, [])

  const getIconRotation = () => {
    const currentTheme = resolvedTheme || theme
    if (currentTheme === 'dark') return 'rotate-90'
    if (currentTheme === 'coral') return '-rotate-45'
    return 'rotate-0'
  }

  const getIconScale = () => {
    const currentTheme = resolvedTheme || theme
    if (currentTheme === 'dark') return 'scale-100'
    if (currentTheme === 'coral') return 'scale-0'
    return 'scale-100'
  }

  const getMoonScale = () => {
    const currentTheme = resolvedTheme || theme
    if (currentTheme === 'dark') return 'scale-100'
    return 'scale-0'
  }

  const getPaletteScale = () => {
    const currentTheme = resolvedTheme || theme
    if (currentTheme === 'coral') return 'scale-100'
    return 'scale-0'
  }

  if (!mounted) {
    return (
      <Button variant="outline" size="icon" disabled>
        <Sun className="h-[1.2rem] w-[1.2rem]" />
        <span className="sr-only">Toggle theme</span>
      </Button>
    )
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="icon">
          <Sun
            className={`h-[1.2rem] w-[1.2rem] transition-all ${getIconRotation()} ${getIconScale()}`}
          />
          <Moon
            className={`absolute h-[1.2rem] w-[1.2rem] transition-all ${getMoonScale()}`}
          />
          <Palette
            className={`absolute h-[1.2rem] w-[1.2rem] transition-all ${getPaletteScale()}`}
          />
          <span className="sr-only">Toggle theme</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => setTheme("light")}>
          Light
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("dark")}>
          Dark
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setTheme("coral")}>
          Coral Silver
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}